import React from 'react';
import { NavLink } from 'react-router-dom';


import { axiosInstance2 } from "../../../utils/axiosConfig";
import cloneDeep from 'lodash/cloneDeep';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen, faFolder } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import QMSErrorHandle from './../../auxil/QMSErrorHandle';
import { Menu } from 'antd';
import 'antd/dist/antd.css';
import {
    FolderOutlined,
    FolderOpenOutlined, FileSearchOutlined, } from '@ant-design/icons';

const { SubMenu } = Menu;

class SessionData extends React.Component {
    //(sessionStorage.getItem('sessionData') == null)?"": JSON.parse(sessionStorage.getItem('sessionData')["date"])
    constructor(props) {
        super(props);
        this.state = {
            path: props.path,
            //sessions: [],
            opendMenus: [],
            opendSubMenus: [],
            afterKey : 0,
            archiveKey : 0,
            //page : 0,
            pageSize : 15,
            dateMenuList : []
        };
        this.props = props;
        //bind state to functions
        // this.toggleMe = this.toggleMe.bind(this);
        this.clickLink = this.clickLink.bind(this);
        this.scrollMenu = this.scrollMenu.bind(this);
        this.processSessions = this.processSessions.bind(this);
        
    }

    endOfData = false;
    sessions = [];
    errorObject = {
        err: false, 
        errCode: null, 
        errType: null, 
        errMsg: null, 
        display : false
    }

    printError(newError){
        this.errorObject = newError;
        this.forceUpdate();
        //this.setState({ alertObj : ""});
        setTimeout(() => { 
            this.errorObject = {
                err: false, 
                errCode: null, 
                errType: null, 
                errMsg: null, 
                display : false
            }
        },
        1000);
    }

    componentDidMount() {
        //get session data for side menu
        let user = { ...this.props.user };

        this.createContent(true, true);
        
    }

    scrollMenu(){

        if(!this.endOfData){
            let container = document.getElementById("item_1$Menu");
            
            let shei = container.scrollHeight;
            let scY = container.scrollTop;
            let clHei = container.clientHeight;
            
            if(shei === (scY+clHei)){
                this.createContent(false, true)
            }else if(scY === 0){
                this.createContent(false, false);
            }

        }
    }

    componentDidUpdate(){
        
        let scrollableSubMenu = document.getElementById("item_1$Menu");
        if(scrollableSubMenu !== null){
            //scrollableSubMenu.addEventListener("scroll", function (){ alert("LUL")});
            scrollableSubMenu.onscroll = this.scrollMenu;
        }
    }

    clickLink(d, t, key) {
        //this.toggleMe(d, true);
        //TOGGLE MENUS
        if (t == 'null') { // DATE SUBMENU SELECTED
            let currentOpndSubMenus = [...this.state.opendSubMenus];
            var subindex = currentOpndSubMenus.indexOf(key);
            if (subindex === -1) { //IF CURRENT SELECTED SUBMENU NOT AVAILABLE, ADD IT
                // currentOpndSubMenus.push(key);
                // this.setState({ opendSubMenus: currentOpndSubMenus });
                this.setState(
                    prevState => ({ opendSubMenus: [...prevState.opendSubMenus, key] }),
                    () => this.props.pushopeneditems(this.state.opendSubMenus, this.state.opendMenus)
                );
            } else { //IF CURRENT SELECTED SUBMENU AVAILABLE, REMOVE IT
                currentOpndSubMenus.splice(subindex, 1)
                this.setState(
                    { opendSubMenus: currentOpndSubMenus },
                    () => this.props.pushopeneditems(this.state.opendSubMenus, this.state.opendMenus)
                );
            }
        } else { // TIME MENU SELECTED
            let currentOpndMenus = [...this.state.opendMenus];
            var menuindex = currentOpndMenus.indexOf(key);
            if (menuindex === -1) { //IF CURRENT SELECTED MENU NOT AVAILABLE, ADD IT
                // this.setState(
                //     prevState => ({ opendMenus: [...prevState.opendMenus, key] }),
                //     () => this.props.pushopeneditems(this.state.opendSubMenus, this.state.opendMenus)
                // );
                this.setState(
                    { opendMenus: [key] },
                    () => this.props.pushopeneditems(this.state.opendSubMenus, this.state.opendMenus)
                );
            } else { //IF CURRENT SELECTED MENU AVAILABLE, REMOVE IT
                currentOpndMenus.splice(menuindex, 1)
                this.setState(
                    { opendMenus: currentOpndMenus },
                    () => this.props.pushopeneditems(this.state.opendSubMenus, this.state.opendMenus)
                );
            }
        }

        if (d != 'null') {
            //set session data to pass sibling <Content>
            var sessionData = {
                date: d,
                time: t
            };

            // pass data through session storage
            sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
        }

    }

    leadingZero(val){
        if(parseInt(val) < 10){
            val = "0"+val;
        }
        return val
    }

    createContent(init, scrollDown){
        let container = null;
        let shei = null;
        let scY = null;
        let clHei = null;

        //let page = this.state.page;
        if(!init){
            container = document.getElementById("item_1$Menu");
            shei = container.scrollHeight;
            scY = container.scrollTop;
            clHei = container.clientHeight;
            container.style.overflowY = "hidden";
        }
        let user = { ...this.props.user };
        let afterKey = this.state.afterKey;
        let archiveKey = this.state.archiveKey;
        //let userId = user.sub.replace("auth0|", "").toString();
        let userId = user["https://myapp.com/UserName"];
        //if scrolling downwards
        if(scrollDown){
            axiosInstance2.post("/api/fileTrace/getUserAggregatedFileTraceSessions",
                {
                    "user" : user.name,
                    "email" : user.email,
                    //"page" : page,
                    "size" : this.state.pageSize,
                    "afterKey" : afterKey,
                    "archiveKey" : archiveKey,
                    "pms" : sessionStorage.getItem('pms'),
                    "userId" : userId
                })
            .then(response => {
                
                if(response.data.error){
                    console.error("ERROR :", response.data.errorMessage);
                    let errorMessage = (response["data"]["display"] != undefined && response["data"]["display"])?response["data"]["errorMessage"]:'Error occured';
                    this.printError({
                        display: true,
                        err: true,
                        errCode: '500',
                        errType: '',
                        errMsg: errorMessage
                    });

                    return;
                }
                let result = response.data.data;
                let bucketSize = Object.keys(result.buckets).length;

                // let stateSessions = {... this.state.sessions};
                let stateSessions = {... this.sessions};
                if(bucketSize > 0){
                    
                    if(bucketSize === this.state.pageSize){
                        if(!result.archiveUsed){
                            this.state.afterKey = ++afterKey;
                        }else{
                            this.state.archiveKey = ++archiveKey;
                        }
                    }else{
                        this.endOfData = true;
                    }
                    
                    let dteKeys = Object.keys(result.buckets);
                    for( let x = 0 ; x < dteKeys.length ; x++){
                        let bucketKey = dteKeys[x];
                        let timeList = result.buckets[bucketKey];
                        
                        for(let y = 0 ; y < timeList.length  ; y++){
                            let formatted = moment(bucketKey+" "+timeList[y], 'MM-DD-YYYY hh:mm:ss A').format('YYYY-MM-DD HH:mm:ss')
                            let dte = moment.utc(formatted);
                            
                            let localSession = moment(dte).local();
                            let fmtSessionTime = moment(localSession).format('hh:mm:ss A');
                            let fmtSessionDate =  moment(localSession).format('MM-DD-YYYY');
                            
                            if(fmtSessionDate in stateSessions){
                                stateSessions[fmtSessionDate].push(fmtSessionTime);
                            }else{
                                stateSessions[fmtSessionDate] = [fmtSessionTime]
                            }
                        }

                    }
                    this.sessions = stateSessions;
                    this.processSessions();
                    //this.setState({"sessions" : stateSessions});
                }
                if(!init){
                    container.style.overflowY = "auto";
                    container.scrollTop = scY-5;
                }
                //alert(JSON.stringify(this.state.afterKeyList) +" ::: "+this.state.opendMenus+" ::: "+this.state.opendSubMenus);
            }).catch((error) => { 
                if(!init){
                    container.style.overflowY = "auto";
                    container.scrollTop = scY-5;
                }
                console.error("ERROR :",error);
                this.printError({
                    display: true,
                    err: true,
                    errCode: '400',
                    errType: '',
                    errMsg: 'Error occured : '+error.message
                });
                
            });

        }else{
            container.style.overflowY = "auto";
            return;
            // let afterKey = null;
            
            // if(afterKeylist.length > 2){
            //     afterKey = afterKeylist[afterKeylist.length - 2];
            // }

            // //let urlString = "page="+page+"&size="+this.state.pageSize+"&afterKey="+JSON.stringify(afterKey);
            // axiosInstance2.post("/api/fileTrace/getUserAggregatedFileTraceSessions",
            // {
            //     "user" : user.name,
            //     "email" : user.email,
            //     //"page" : page,
            //     "size" : this.state.pageSize,
            //     "afterKey" : JSON.stringify(afterKey)
            // })
            // .then(response => {
            //     // alert(JSON.stringify(response.data));
            //     if(response.data.error){
            //         alert("ERROR : "+response.data.errorMessage);
            //         return;
            //     }
            //     let result = response.data.data;
            //     let bucketSize = Object.keys(result.buckets).length;
            //     if(bucketSize > 0){
            //         if(afterKey !== null || afterKeylist.length > 1){
            //             this.state.afterKeyList.pop();
            //         }
            //         if(!init){
            //             container.scrollTop = (shei - clHei)/4;
            //             container.style.height = (bucketSize * 40)+"px";
            //         }
            //         this.setState({ "sessions" : result.buckets})
            //     }
            //     if(!init){
            //         container.style.overflowY = "auto";
            //     }
            //     //alert(JSON.stringify(this.state.afterKeyList) +" ::: "+this.state.opendMenus+" ::: "+this.state.opendSubMenus);
            // }).catch((error) => { 
            //     alert("ERROR :" + error); 
            //     if(!init){
            //         container.style.overflowY = "auto";
            //     } 
            // });
        }

    }

    firstKey = "";
    firstMenuKey = "";
    selectFirstSession() {
        //alert("Setting state : "+this.firstKey+" : "+this.firstMenuKey)
        
        const event = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        });
        const firstSession = document.getElementById(this.firstKey); 
        // const filetraceMenu = document.getElementById("filetrace"); 
        // const firstDate = document.getElementById(this.firstMenuKey); 
        
        // if(filetraceMenu != null){
        //     //alert("DoClick");
        //     const cancelled = !filetraceMenu.dispatchEvent(event);
          
        //     if (cancelled) {
        //       //alert("cancelled");
        //     }

        // }

        // if(firstDate != null){
        //     //alert("DoClick");
        //     const cancelled = !firstDate.dispatchEvent(event);
          
        //     if (cancelled) {
        //       //alert("cancelled");
        //     }

        // }

        if(firstSession != null){
            //alert("DoClick");
            const cancelled = !firstSession.dispatchEvent(event);
          
            if (cancelled) {
              //alert("cancelled");
            }

        }
    }

    componentDidUpdate(){
        //alert( "First key : "+this.firstKey+" | Session Data : "+JSON.parse(sessionStorage.getItem('sessionData')));
        if(this.firstKey != "" && JSON.parse(sessionStorage.getItem('sessionData')) === null){
            //this.selectFirstSession();
        }
    }

    processSessions(){

        //array to group session ul components by day
        const { pushopeneditems, ...rest } = this.props;
        //console.log('{...this.props}', { ...this.props });
        let sessionGroups = [];
        let dateMenuList = [];
        //copy sorted data
        //let sessions = cloneDeep(this.state.sessions);
        let sessions = cloneDeep(this.sessions);

        let keyList = Object.keys(sessions);
        let fistKeySet = false;
        //maintain individual collapses
        for (let x = 0; x < keyList.length; x++) {
            //loop daily sessions to create time wise li
            let subSessionList = sessions[keyList[x]];

            //contains time sessions
            let timeMenuList = [];
            subSessionList.forEach((sess) => {
                
                if(!fistKeySet){
                    this.firstKey = 'Nav_'+keyList[x] + '_' + sess;
                    fistKeySet = true;
                }

                timeMenuList.push(<Menu.Item
                    {...rest}
                    onClick={() => this.clickLink(keyList[x], sess, keyList[x] + '_' + sess)}
                    key={keyList[x] + '_' + sess}
                    id={keyList[x] + '_' + sess}
                >
                    <NavLink id={'Nav_'+keyList[x] + '_' + sess} to="/filetrace">{sess}</NavLink>
                </Menu.Item>)
            });

            let liComp = {
                'datelist': keyList[x],
                'timelist': timeMenuList
            }
            // //add to date li list
            sessionGroups.push(liComp);
        }
        let firstMenu = true;
        sessionGroups.forEach((sessgrp) => {
            if(firstMenu){
                this.firstMenuKey = sessgrp.datelist;
                firstMenu = false;
            }
            
            dateMenuList.push(
                <SubMenu
                    {...rest}
                    onTitleClick={() => this.clickLink(sessgrp.datelist, 'null', sessgrp.datelist)}
                    key={sessgrp.datelist}
                    id={sessgrp.datelist}
                    children={sessgrp.timelist}
                    className="colorRed"
                    title={
                        // <NavLink to="/filetrace">
                            < span >
                                {/* {(this.state.collapse != sessgrp.datelist) ? ( */}
                                {(this.state.opendSubMenus.indexOf(sessgrp.datelist) == -1) ? (
                                    <FolderOutlined />
                                ) : (
                                    <FolderOpenOutlined />
                                )}
                                <span>{sessgrp.datelist}</span>
                            </ span>
                        //</NavLink>
                    }
                >
                </SubMenu>
            )
        });

        this.setState({ 
            "dateMenuList" : dateMenuList,
            "opendMenus" : [this.firstKey],
            "opendSubMenus" : ["filetrace", this.firstMenuKey]
        })
    }

    render() {
        
        const { pushopeneditems, ...rest } = this.props;
        
        return (
            
                (this.errorObject.err === true)?(
                    <QMSErrorHandle errordetails={this.errorObject} />
                ):(
                    <SubMenu
                        {...rest}
                        key="filetrace"
                        id="filetrace"
                        title={
                            <span>
                                <FileSearchOutlined />
                                <span>File Tracing</span>
                            </span>
                        }
                        onTitleClick={() => this.clickLink('null', 'null', 'filetrace')}
                        children={this.state.dateMenuList}
                    >
                    </SubMenu>
                )
        )
    }
}

export default SessionData;